import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editPersonalizedConfigOptions } from "~/store/actions/actions.personalizedConfigOptions";
import { getPersonalizedConfigOption } from "~/store/selectors/selector.configOptions";

export const useFilterPinToSidebar = (projectId) => {
  const dispatch = useDispatch();
  const projectIdsWithShownSidebar = useSelector((state) =>
    getPersonalizedConfigOption(state, "show_project_tasks_sidebar")
  );

  const value = useMemo(() => projectIdsWithShownSidebar?.includes(projectId), [projectId, projectIdsWithShownSidebar]);

  const handler = useCallback(
    (checked) => {
      let value = {};
      value.show_project_tasks_sidebar = checked
        ? [...projectIdsWithShownSidebar, projectId]
        : projectIdsWithShownSidebar.filter((id) => id !== projectId);

      dispatch(editPersonalizedConfigOptions(value));
    },
    [dispatch, projectId, projectIdsWithShownSidebar]
  );

  return [value, handler];
};
